/**
 * A unix-seconds timestamp in the user's local zone, with the UTC instant
 * and the relative age on hover (spec §13: local time, UTC on hover).
 */
import { fmtAgo, fmtTime, fmtTimeCompact, fmtTimeShort } from "@/lib/format";
import { useCompactTime } from "./compactTime";

function utcIso(t: number): string {
  return new Date(t * 1000)
    .toISOString()
    .replace("T", " ")
    .replace(/\.\d{3}Z$/, " UTC");
}

export function TimeStamp({
  t,
  short = false,
  className = "",
}: {
  t: number | undefined | null;
  /** "MM-dd HH:mm" instead of the full date-time */
  short?: boolean;
  className?: string;
}) {
  const compact = useCompactTime();
  if (t === undefined || t === null || !Number.isFinite(t))
    return <span className={`num ${className}`}>–</span>;
  return (
    <time
      dateTime={new Date(t * 1000).toISOString()}
      title={`${utcIso(t)} · ${fmtAgo(t)}`}
      className={`num ${className}`}
    >
      {short ? fmtTimeShort(t) : compact ? fmtTimeCompact(t) : fmtTime(t)}
    </time>
  );
}
